import { r as registerTranslation, _ as __decorate, a as __metadata, b as BaseLocalizedComponent } from '../index-Blpj1lVH.js';
import { css, html, nothing } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import 'lit/directive.js';

var styles = css`@charset "UTF-8";
.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.d-flex {
  display: flex !important;
}

.bg-dark {
  --bsi-bg-opacity: 1;
  background-color: rgba(var(--bsi-dark-rgb), var(--bsi-bg-opacity)) !important;
}

.border-top {
  border-top: var(--bsi-border-base) var(--bsi-border-style) var(--bsi-border-color) !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.text-end {
  text-align: right !important;
}

.text-muted {
  --bsi-text-opacity: 1;
  color: hsl(210, 17%, 44%) !important;
}

@media (min-width: 576px) {
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
}
@media (min-width: 768px) {
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .text-md-end {
    text-align: right !important;
  }
}
@media (min-width: 992px) {
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
}
@media (min-width: 1200px) {
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
}
@media (min-width: 1400px) {
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
}
@media print {
  .d-print-flex {
    display: flex !important;
  }
}
it-button {
  --it-host-display: inline-block;
  display: var(--it-host-display);
  width: auto;
  cursor: default !important;
}
it-button:not(:defined) {
  --it-host-display: inline-flex;
  align-items: center;
}
it-button:not(:defined):has(it-progress) {
  position: relative;
}
it-button:not(:defined):has(it-progress) it-progress {
  --it-fouc-bg: #ccc;
}
it-button it-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  width: 100%;
}
it-button it-progress::part(progress) {
  --bsi-progress-border-radius: 0 0 var(--bsi-radius-smooth) var(--bsi-radius-smooth);
}

.bg-dark it-button::part(link) {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-color-link-hover: var(--bsi-color-text-inverse);
}
.bg-dark it-button::part(primary) {
  --bsi-btn-text-color: var(--bsi-color-text-primary);
  --bsi-btn-background: var(--bsi-color-background-inverse);
}
.bg-dark it-button::part(primary):hover {
  --bsi-btn-background: color-mix(in srgb, var(--bsi-color-background-inverse) 85%, black);
}
.bg-dark it-button::part(primary):active {
  --bsi-btn-background: color-mix(in srgb, var(--bsi-color-background-inverse) 80%, black);
}
.bg-dark it-button[variant=primary][outline]::part(button) {
  --bsi-btn-background: transparent;
  --bsi-btn-outline-border-color: var(--bsi-color-border-inverse);
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
}
.bg-dark it-button[variant=primary][outline]::part(button):hover {
  --btn-boxshadow-color-darken: color-mix(in srgb, var(--bsi-color-border-inverse) 80%, black);
  --btn-boxshadow-color-desaturated: color-mix(in srgb, var(--btn-boxshadow-color-darken) 80%, gray);
  --bsi-btn-outline-border-color: var(
    --btn-boxshadow-color-desaturated
  );
}
.bg-dark it-button::part(secondary) {
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
  --bsi-btn-background: var(--bsi-color-background-secondary);
}
.bg-dark it-button::part(secondary):hover, .bg-dark it-button::part(secondary):active {
  --bsi-btn-background: color-mix(in srgb, var(--bsi-color-background-secondary) 85%, black);
}
.bg-dark it-button[variant=secondary][outline]::part(button) {
  --bsi-btn-background: transparent;
  --bsi-btn-text-color: var(--bsi-color-text-inverse);
}
.bg-dark it-button[variant=secondary][outline]::part(button):hover, .bg-dark it-button[variant=secondary][outline]::part(button):active {
  --btn-boxshadow-color-darken: color-mix(in srgb, var(--bsi-color-background-secondary) 80%, black);
  --btn-boxshadow-color-desaturated: color-mix(in srgb, var(--btn-boxshadow-color-darken) 80%, gray);
  --bsi-btn-outline-border-color: var(
    --btn-boxshadow-color-desaturated
  );
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

body {
  font-family: var(--bsi-font-sans);
}

p,
ul,
ol,
dl {
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}

caption,
figcaption {
  font-size: var(--bsi-caption-font-size);
  line-height: var(--bsi-caption-leading);
}

b,
strong {
  font-weight: var(--bsi-font-weight-strong);
}

mark,
code {
  padding: 0 var(--bsi-spacing-3xs);
}

mark {
  background-color: var(--bsi-highlight-background);
}

pre,
code,
kbd,
samp {
  border-radius: var(--bsi-radius-smooth);
  font-family: var(--bsi-font-mono);
}

ins,
del {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--bsi-spacing-3xs) var(--bsi-spacing-m);
  font: var(--bsi-body-font-size);
  text-decoration: none;
}

ins {
  background-color: var(--bsi-ins-background);
  text-decoration: none;
}

del {
  background-color: var(--bsi-del-background);
}

del::before,
ins::before {
  position: absolute;
  left: 0.5rem;
}

del::before {
  content: "−";
}

ins::before {
  content: "+";
}

kbd {
  margin: 0 2px;
  padding: 2px var(--bsi-spacing-3xs);
  border: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  background-color: var(--bsi-color-background-secondary-lighter);
  box-shadow: var(--bsi-elevation-low), 0 2px 0 0 hsla(255, 0%, 100%, 0.7) inset;
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-font-size-1);
  font-weight: var(--bsi-font-weight-solid);
  white-space: nowrap;
}
kbd kbd {
  padding: 0;
  font-size: var(--bsi-code-font-size);
}

small,
.small {
  font-size: var(--bsi-caption-font-size);
}

.x-small {
  font-size: var(--bsi-font-size-1);
}

h1,
.h1 {
  font-size: var(--bsi-heading-1-font-size);
}

h2,
.h2 {
  font-size: var(--bsi-heading-2-font-size);
}

h3,
.h3 {
  font-size: var(--bsi-heading-3-font-size);
}

h4,
.h4 {
  font-size: var(--bsi-heading-4-font-size);
}

h5,
.h5 {
  font-size: var(--bsi-heading-5-font-size);
}

h6,
.h6 {
  font-size: var(--bsi-heading-6-font-size);
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 0;
  margin-bottom: var(--bsi-heading-spacing);
  line-height: var(--bsi-heading-leading);
}
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h1, p + h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h1,
p + .h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h2,
p + h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h2,
p + .h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h3,
p + h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h3,
p + .h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h4,
p + h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h4,
p + .h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h5,
p + h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h5,
p + .h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h6,
p + h6,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h6,
p + .h6 {
  padding-top: var(--bsi-spacing-s);
}

h1,
h2,
h3,
.h1,
.h2,
.h3 {
  font-weight: var(--bsi-heading-font-weight);
}

h4,
h5,
h6,
.h4,
.h5,
.h6 {
  font-weight: var(--bsi-heading-font-weight-weak);
}

h1,
.h1,
.display-1 {
  letter-spacing: -1px;
}

.font-serif {
  font-family: var(--bsi-font-serif) !important;
}

.font-sans-serif {
  font-family: var(--bsi-font-sans) !important;
}

.font-monospace {
  font-family: var(--bsi-font-mono) !important;
}

.display-1 {
  font-size: var(--bsi-display-font-size);
  font-weight: var(--bsi-heading-font-weight);
  line-height: var(--bsi-heading-leading);
}

.lead {
  font-size: var(--bsi-lead-font-size);
  font-weight: var(--bsi-lead-font-weight);
  line-height: var(--bsi-lead-leading);
}

blockquote,
.blockquote {
  margin: var(--bsi-spacing-m) 0;
  margin-left: var(--bsi-spacin-inline-xs);
  padding: var(--bsi-spacing-s);
  border-left: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}
blockquote > :last-child,
.blockquote > :last-child {
  margin-bottom: 0;
}
blockquote.text-end,
.blockquote.text-end {
  margin-right: var(--bsi-spacin-inline-xs);
  border-right: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
}
blockquote.text-center, blockquote.text-end, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.text-end,
.blockquote.blockquote-simple {
  margin-left: 0;
  border-right: none;
  border-left: none;
}
blockquote.text-center, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.blockquote-simple {
  padding: 0;
}
blockquote.blockquote-simple,
.blockquote.blockquote-simple {
  font-style: italic;
}
blockquote.blockquote-card,
.blockquote.blockquote-card {
  margin-left: 0;
  padding: var(--bsi-spacing-m);
  background-color: var(--bsi-color-background-inverse);
  box-shadow: var(--bsi-elevation-low);
}
blockquote.blockquote-card .blockquote-footer,
.blockquote.blockquote-card .blockquote-footer {
  font-size: inherit;
}
blockquote.blockquote-card .blockquote-footer:before,
.blockquote.blockquote-card .blockquote-footer:before {
  content: none;
}
blockquote.blockquote-card.dark,
.blockquote.blockquote-card.dark {
  border-left: none;
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
blockquote.blockquote-card.dark .blockquote-footer,
.blockquote.blockquote-card.dark .blockquote-footer {
  color: var(--bsi-color-text-inverse);
}

.blockquote-footer {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-label-font-size);
}
.blockquote-footer::before {
  content: "— ";
}
.bg-dark .blockquote-footer {
  color: var(--bsi-color-text-muted);
}

.initialism {
  font-size: var(--bsi-label-font-size-s);
  text-transform: uppercase;
}

.progress {
  --bsi-progress-bg: var(--bsi-color-background-secondary-lighter);
  --bsi-progress-border-radius: var(--bsi-radius-smooth);
  --bsi-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bsi-progress-label-color: var(--bsi-color-text-secondary);
  --bsi-progress-label-font-size: var(--bsi-label-font-size-xs);
  --bsi-progress-bar-transition: width 0.5s ease;
  --bsi-progress-bar-bg: var(--bsi-color-background-secondary);
  --bsi-progress-height: 4px;
  --bsi-progress-bg: var(--bsi-color-background-secondary-lighter);
  --bsi-progress-border-radius: var(--bsi-radius-smooth);
  --bsi-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bsi-progress-label-color: var(--bsi-color-text-secondary);
  --bsi-progress-label-font-size: var(--bsi-label-font-size-xs);
  --bsi-progress-bar-transition: width 0.5s ease;
  --bsi-progress-bar-bg: var(--bsi-color-background-secondary);
  --bsi-progress-height: 4px;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 16px;
  }
}
.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bsi-progress-height) var(--bsi-progress-height);
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

@keyframes progressBarIndeterminate {
  0% {
    left: -5%;
  }
  50% {
    width: 66%;
  }
  100% {
    left: 100%;
    width: 33%;
  }
}
/* stylelint-disable-next-line no-duplicate-selectors */
.progress {
  display: flex;
  overflow: hidden;
  background-color: var(--bsi-progress-bg);
  border-radius: var(--bsi-progress-border-radius);
  height: var(--bsi-progress-height);
  box-shadow: none;
}
.progress.progress-color {
  background-color: var(--bsi-color-background-secondary-lighter);
}
.progress.progress-indeterminate {
  position: relative;
}
.progress.progress-indeterminate .progress-bar {
  width: 0;
  animation: progressBarIndeterminate 1.4s cubic-bezier(0.77, 0, 0.175, 1) infinite forwards;
  position: absolute;
  top: 0;
  bottom: 0;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  transition: var(--bsi-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
.progress-bar {
  background-color: var(--bsi-progress-bar-bg);
}

.progress-bar-label {
  text-align: right;
  font-size: var(--bsi-progress-label-font-size);
  color: var(--bsi-progress-label-color);
  font-weight: 500;
}

.btn-progress .progress {
  display: block;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  border-radius: 0 0 var(--bsi-progress-border-radius) var(--bsi-progress-border-radius);
}
.btn-progress .progress-bar {
  height: var(--bsi-progress-height);
}

.steppers {
  --bsi-stepper-active-indicator-height: 2px;
  --bsi-stepper-index-color: var(--bsi-color-text-secondary);
  --bsi-stepper-background: transparent;
  --bsi-stepper-border-color: var(--bsi-color-border-subtle);
  --bsi-stepper-dot-color: var(--bsi-color-background-subtle);
  --bsi-stepper-dot-gap: 8px;
  --bsi-stepper-dot-size: 4px;
  --bsi-stepper-font-size: var(--bsi-label-font-size-l);
  --bsi-stepper-icon-size: var(--bsi-icon-size-m);
  --bsi-stepper-icon-color: var(--bsi-stepper-item-text-color);
  --bsi-stepper-icon-confirmed: var(--bsi-icon-success);
  --bsi-stepper-index-font-size: var(--bsi-label-font-size-s);
  --bsi-stepper-item-background: var(--bsi-stepper-background);
  --bsi-stepper-item-border-color-active: var(--bsi-color-border-primary);
  --bsi-stepper-item-text-color: var(--bsi-color-text-muted);
  --bsi-stepper-nav-height: 64px;
  --bsi-stepper-number-background-active: var(--bsi-color-background-primary);
  --bsi-stepper-number-border-color: var(--bsi-color-border-subtle);
  --bsi-stepper-number-color: var(--bsi-color-text-muted);
  --bsi-stepper-number-size: 2rem;
  --bsi-stepper-progress-height: 2px;
  --bsi-stepper-spacing-x: var(--bsi-spacing-xs);
  --bsi-stepper-spacing-y: var(--bsi-spacing-s);
}
@media (min-width: 992px) {
  .steppers {
    --bsi-stepper-background: transparent;
  }
}

.steppers-index {
  flex-shrink: 0;
  margin-left: auto;
  color: var(--bsi-stepper-index-color);
  font-size: var(--bsi-stepper-index-font-size);
  font-weight: var(--bsi-font-weight-solid);
}
@media (min-width: 992px) {
  .steppers-index {
    display: none;
  }
}
.steppers-index span {
  margin-left: var(--bsi-spacing-3xs);
}
.steppers-index span.active {
  --bsi-stepper-index-color: var(--bsi-color-text-base);
}

.steppers-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bsi-stepper-background);
}
@media (min-width: 992px) {
  .steppers-nav {
    align-items: center;
    margin-top: var(--bsi-spacing-s);
    background: none;
    box-shadow: none;
  }
  .steppers-nav .steppers-progress,
  .steppers-nav .steppers-dots {
    display: none;
  }
  .steppers-nav .steppers-btn-confirm {
    display: block;
    margin-left: auto;
  }
}
.steppers-nav .steppers-progress,
.steppers-nav .steppers-dots {
  width: 20%;
}
.steppers-nav .steppers-progress .progress {
  height: var(--bsi-stepper-progress-height);
}
.steppers-nav .steppers-dots {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}
.steppers-nav .steppers-dots li {
  width: var(--bsi-stepper-dot-size);
  min-width: var(--bsi-stepper-dot-size);
  height: var(--bsi-stepper-dot-size);
  margin-right: var(--bsi-stepper-dot-gap);
  padding: 0;
  list-style-type: none;
  border-radius: 50%;
  background: var(--bsi-stepper-dot-color);
}
.steppers-nav .steppers-dots li.done {
  --bsi-stepper-dot-color: var(--bsi-icon-primary);
}

.steppers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bsi-stepper-spacing-y) var(--bsi-stepper-spacing-x);
  background: var(--bsi-stepper-background);
}
@media (max-width: 991.98px) {
  .steppers-header {
    border-bottom: var(--bsi-stepper-active-indicator-height) solid var(--bsi-stepper-border-color);
  }
}
@media (min-width: 992px) {
  .steppers-header {
    padding: 0;
  }
}
.steppers-header ul {
  display: flex;
  width: 100%;
  padding: 0;
  margin-bottom: 0;
}
.steppers-header ul li {
  display: flex;
  align-items: center;
  list-style-type: none;
  background-color: var(--bsi-stepper-item-background);
  color: var(--bsi-stepper-item-text-color);
  font-size: var(--bsi-stepper-font-size);
  font-weight: var(--bsi-font-weight-solid);
  line-height: var(--bsi-label-leading);
}
@media (min-width: 992px) {
  .steppers-header ul li {
    position: relative;
    flex-grow: 1;
    padding: var(--bsi-stepper-spacing-y) var(--bsi-stepper-spacing-x);
    border-left: 1px solid var(--bsi-stepper-border-color);
  }
  .steppers-header ul li:nth-last-child(1) {
    border-right: 1px solid var(--bsi-stepper-border-color);
  }
  .steppers-header ul li.steppers-index {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .steppers-header ul li:not(.active) {
    position: absolute;
    display: block;
    height: 0;
    clip: rect(1px, 1px, 1px, 1px);
  }
}
.steppers-header ul li.active {
  --bsi-stepper-item-text-color: var(--bsi-color-text-primary);
  --bsi-stepper-number-border-color: var(--bsi-color-border-primary);
  --bsi-stepper-number-background: var(--bsi-color-background-primary);
}
@media (min-width: 992px) {
  .steppers-header ul li.active {
    border-bottom: var(--bsi-stepper-active-indicator-height) solid var(--bsi-stepper-item-border-color-active);
  }
}
.steppers-header ul li.confirmed {
  --bsi-stepper-item-text-color: var(--bsi-color-text-base);
  --bsi-stepper-number-border-color: var(--bsi-color-border-success);
  --bsi-stepper-number-background: var(--bsi-color-background-success);
}
.steppers-header ul li.active, .steppers-header ul li.confirmed {
  --bsi-stepper-number-color: var(--bsi-color-text-inverse);
}
.steppers-header ul li.steppers-index {
  display: block;
}
.steppers-header .icon {
  width: var(--bsi-stepper-icon-size);
  height: var(--bsi-stepper-icon-size);
  margin-right: var(--bsi-spacing-xxs);
  fill: var(--bsi-stepper-icon-color);
}
.steppers-header .icon.steppers-success {
  margin-left: auto;
  fill: var(--bsi-stepper-icon-confirmed);
}
.steppers-header .steppers-number .icon.steppers-success {
  --bsi-stepper-icon-confirmed: var(--bsi-icon-inverse);
  margin: 0;
}
.steppers-header .steppers-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--bsi-stepper-number-size);
  height: var(--bsi-stepper-number-size);
  margin-right: var(--bsi-spacing-xxs);
  border: 1px solid var(--bsi-stepper-number-border-color);
  border-radius: var(--bsi-radius-rounded);
  background-color: var(--bsi-stepper-number-background, transparent);
  color: var(--bsi-stepper-number-color);
  line-height: var(--bsi-stepper-number-size);
}
.steppers-header .steppers-number .icon {
  margin-right: 0;
  margin-left: 0;
}

.steppers-save {
  flex-direction: column;
  justify-content: flex-start;
}
@media (min-width: 992px) {
  .steppers-save {
    flex-direction: row;
    justify-content: flex-end;
  }
}
.steppers-save > div,
.steppers-save > button,
.steppers-save > a {
  flex: 0 0 auto;
  align-self: flex-start;
  width: fit-content;
  max-width: 100%;
}

.steppers.bg-dark,
.bg-dark .steppers {
  --bsi-stepper-border-color: var(--bsi-color-slate-52);
  --bsi-stepper-icon-color: var(--bsi-color-slate-62);
  --bsi-stepper-icon-confirmed: var(--bsi-icon-inverse);
  --bsi-stepper-item-text-color: var(--bsi-color-text-inverse);
  --bsi-stepper-item-border-color-active: var(--bsi-color-border-inverse);
  --bsi-stepper-number-border-color: var(--bsi-color-slate-52);
  --bsi-stepper-number-color: var(--bsi-color-slate-62);
}
.steppers.bg-dark .steppers-header ul li,
.bg-dark .steppers .steppers-header ul li {
  --bsi-stepper-item-text-color: var(--bsi-color-slate-62);
}
.steppers.bg-dark .steppers-header ul li.confirmed,
.bg-dark .steppers .steppers-header ul li.confirmed {
  --bsi-stepper-item-text-color: var(--bsi-color-text-inverse);
}
.steppers.bg-dark .steppers-header ul li.active,
.bg-dark .steppers .steppers-header ul li.active {
  --bsi-stepper-item-text-color: var(--bsi-color-text-inverse);
  --bsi-stepper-number-color: var(--bsi-color-text-secondary);
  --bsi-stepper-number-background: var(--bsi-color-background-inverse);
}

:host {
  display: block;
  width: 100%;
}

.steppers {
  width: 100%;
}

.steppers it-icon {
  --bsi-icon-default: var(--bsi-stepper-icon-color);
}

.steppers-header ul li.confirmed it-icon.steppers-success {
  --bsi-icon-default: var(--bsi-stepper-icon-confirmed);
}

.steppers.bg-dark .steppers-header ul li.confirmed it-icon.steppers-success {
  --bsi-icon-default: var(--bsi-stepper-icon-confirmed);
}

:host([mobile-progress-on-desktop]) .steppers-nav .steppers-progress {
  display: block;
}

:host([mobile-progress-on-desktop]) .steppers-nav .steppers-dots {
  display: flex;
}

.steppers-number it-icon {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  margin-right: 0;
}`;

const translation$1 = {
    $code: 'it',
    $name: 'Italiano',
    $dir: 'ltr',
    back: 'Indietro',
    next: 'Avanti',
    confirm: 'Conferma',
    confirmed: 'Confermato',
    active: 'Attivo',
    step: 'Passo',
    progress: 'Avanzamento dello stepper',
    outOf: 'di',
    navigation: 'Navigazione stepper',
};

const translation = {
    $code: 'en',
    $name: 'English',
    $dir: 'ltr',
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',
    confirmed: 'Confermato',
    active: 'Active',
    step: 'Step',
    progress: 'Stepper progress',
    outOf: 'out of',
    navigation: 'Stepper navigation',
};

registerTranslation(translation$1);
registerTranslation(translation);
/**
 * `it-stepper` è il componente contenitore per una procedura a più passi.
 *
 * Gestisce la navigazione tra gli step, il rendering dell'intestazione,
 * dell'area contenuto e dei controlli di navigazione.
 *
 * ## Struttura attesa
 *
 * ```html
 * <it-stepper header-variant="numbers">
 *   <it-stepper-step>
 *     <span slot="label">Primo contenuto</span>
 *     <p>Contenuto del primo step</p>
 *   </it-stepper-step>
 *   <it-stepper-step>
 *     <span slot="label">Secondo contenuto</span>
 *     <p>Contenuto del secondo step</p>
 *   </it-stepper-step>
 *   <it-stepper-step>
 *     <span slot="label">Terzo contenuto</span>
 *     <p>Contenuto del terzo step</p>
 *   </it-stepper-step>
 * </it-stepper>
 * ```
 *
 * @slot - Slot di default per gli elementi `it-stepper-step`.
 *
 * @fires it-stepper-change - Emesso quando lo step attivo cambia.
 *   `detail.step` contiene il nuovo indice (0-based), `detail.prevStep` quello precedente.
 * @fires it-stepper-save - Emesso quando l'utente clicca il pulsante "Salva".
 * @fires it-stepper-confirm - Emesso quando l'utente clicca il pulsante "Conferma".
 */
let ItStepper = class ItStepper extends BaseLocalizedComponent {
    constructor() {
        super(...arguments);
        /**
         * Indice (0-based) dello step attivo.
         * Modificando questo attributo si naviga direttamente a un determinato step.
         */
        this.current = 0;
        /** Variante con sfondo scuro. Aggiunge la classe `.bg-dark` al contenitore. */
        this.dark = false;
        /**
         * Variante dell'intestazione degli step.
         * - `text`: solo testo
         * - `icons`: icona + testo (richiede l'attributo `icon` su ogni `it-stepper-step`)
         * - `numbers`: numero ordinale + testo
         */
        this.headerVariant = 'text';
        /**
         * Indicatore di progresso mobile mostrato tra i pulsanti di navigazione.
         * - `bar`: barra di avanzamento
         * - `dots`: pallini
         * - `''` (vuoto): nessun indicatore (default)
         *
         * Su desktop l'indicatore è sempre nascosto (comportamento BSI nativo).
         */
        this.mobileProgress = '';
        /** Mostra progress bar o pallini anche a desktop, comportamento utile per anteprime e documentazione. */
        this.mobileProgressOnDesktop = false;
        /**
         * Mostra il pulsante "Conferma" al posto del pulsante "Avanti".
         * Utile per l'ultimo step o per step che richiedono conferma esplicita su mobile.
         */
        this.showConfirm = false;
        this._stepCount = 0;
    }
    get _steps() {
        return Array.from(this.querySelectorAll('it-stepper-step'));
    }
    connectedCallback() {
        super.connectedCallback?.();
        this._syncSteps(true);
    }
    willUpdate(changed) {
        super.willUpdate?.(changed);
        if (changed.has('current') && this._stepCount > 0) {
            const currentIndex = this._currentIndex;
            if (this.current !== currentIndex)
                this.current = currentIndex;
        }
    }
    updated(changed) {
        super.updated?.(changed);
        if (changed.has('current')) {
            this._syncSteps();
        }
    }
    get _maxNavigableIndex() {
        return Math.max(this._stepCount - 1, 0);
    }
    get _currentIndex() {
        return this._clampIndex(this.current);
    }
    _clampIndex(index) {
        const numericIndex = Number.isFinite(index) ? Math.trunc(index) : 0;
        return Math.min(Math.max(numericIndex, 0), this._maxNavigableIndex);
    }
    _syncSteps(clampCurrent = false) {
        const steps = this._steps;
        const previousStepCount = this._stepCount;
        this._stepCount = steps.length;
        const currentIndex = this._currentIndex;
        if (clampCurrent && this.current !== currentIndex) {
            this.current = currentIndex;
        }
        steps.forEach((_, index) => {
            const stepElement = steps[index];
            stepElement.active = index === currentIndex;
            stepElement.confirmed = index < currentIndex;
        });
        if (previousStepCount !== this._stepCount && this.hasUpdated) {
            this.requestUpdate();
        }
    }
    _goToStep(nextStep) {
        const prevStep = this._currentIndex;
        const step = this._clampIndex(nextStep);
        if (step === prevStep)
            return;
        this.current = step;
        this.dispatchEvent(new CustomEvent('it-stepper-change', {
            detail: { step, prevStep },
            bubbles: true,
            composed: true,
        }));
    }
    /** Avanza al prossimo step, se disponibile. */
    next() {
        this._goToStep(this._currentIndex + 1);
    }
    /** Torna al passo precedente, se disponibile. */
    prev() {
        this._goToStep(this._currentIndex - 1);
    }
    _handleConfirm() {
        this.dispatchEvent(new CustomEvent('it-stepper-confirm', { bubbles: true, composed: true }));
    }
    _handleSave() {
        this.dispatchEvent(new CustomEvent('it-stepper-save', { bubbles: true, composed: true }));
    }
    _handleSlotChange() {
        this._syncSteps(true);
    }
    // eslint-disable-next-line class-methods-use-this
    _getStepLabel(step) {
        return step.querySelector(':scope > [slot="label"]')?.cloneNode(true) ?? '';
    }
    _renderHeaderItem(step, index) {
        const isActive = index === this._currentIndex;
        const isConfirmed = index < this._currentIndex;
        const liClasses = this.composeClass({
            active: isActive,
            confirmed: isConfirmed,
            'no-line': this.headerVariant === 'numbers' && isActive,
        });
        const confirmedIcon = html `
      <it-icon class="icon steppers-success" name="it-check" aria-hidden="true"></it-icon>
      <span class="visually-hidden">${this.$t('confirmed')}</span>
    `;
        const activeHint = isActive ? html `<span class="visually-hidden">${this.$t('active')}</span>` : '';
        const labelContent = this._getStepLabel(step);
        if (this.headerVariant === 'icons') {
            return html `
        <li class=${liClasses} aria-current=${ifDefined(isActive ? 'step' : undefined)}>
          ${step.icon ? html `<it-icon class="icon" name=${step.icon} aria-hidden="true"></it-icon>` : nothing}
          ${labelContent} ${isActive ? activeHint : ''} ${isConfirmed ? confirmedIcon : ''}
        </li>
      `;
        }
        if (this.headerVariant === 'numbers') {
            const numberContent = isConfirmed
                ? html `
            <it-icon class="icon steppers-success" name="it-check" aria-hidden="true"></it-icon>
            <span class="visually-hidden">${this.$t('confirmed')} ${this.$t('step')} ${index + 1}</span>
          `
                : html `<span class="visually-hidden">${isActive ? this.$t('active') : ''} ${this.$t('step')} </span>${index + 1}`;
            return html `
        <li class=${liClasses} aria-current=${ifDefined(isActive ? 'step' : undefined)}>
          <span class="steppers-number">${numberContent}</span>
          ${labelContent}
        </li>
      `;
        }
        // Default: text only
        return html `
      <li class=${liClasses} aria-current=${ifDefined(isActive ? 'step' : undefined)}>
        ${labelContent} ${isActive ? activeHint : ''} ${isConfirmed ? confirmedIcon : ''}
      </li>
    `;
    }
    _renderMobileIndex() {
        const currentIndex = this._currentIndex;
        const total = this._stepCount;
        if (this.headerVariant === 'numbers') {
            return html `
        <span class="steppers-index" aria-hidden="true">
          ${Array.from({ length: total }, (_, i) => i).map((i) => html `<span class=${ifDefined(i === currentIndex ? 'active' : undefined)}>${i + 1}</span>`)}
        </span>
      `;
        }
        return html `<span class="steppers-index" aria-hidden="true">${currentIndex + 1}/${total}</span>`;
    }
    _renderProgressBar() {
        const total = this._stepCount;
        const percent = total > 1 ? Math.round((this._currentIndex / (total - 1)) * 100) : 100;
        return html `
      <div class="steppers-progress" part="progress">
        <div class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            style="width: ${percent}%"
            aria-label=${this.$t('progress')}
            aria-valuenow=${percent}
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
    `;
    }
    _renderDots() {
        const currentIndex = this._currentIndex;
        const total = this._stepCount;
        return html `
      <ul class="steppers-dots" part="dots">
        ${Array.from({ length: total }, (_, i) => i).map((i) => html `
            <li class=${this._getDotClass(i)} aria-current=${ifDefined(i === currentIndex ? 'step' : undefined)}>
              <span class="visually-hidden"
                >${this.$t('step')} ${i + 1} ${this.$t('outOf')} ${total}${this._getDotStateText(i)}</span
              >
            </li>
          `)}
      </ul>
    `;
    }
    _getDotClass(index) {
        if (index < this._currentIndex)
            return 'done';
        if (index === this._currentIndex)
            return 'done active';
        return '';
    }
    _getDotStateText(index) {
        if (index < this._currentIndex)
            return ` - ${this.$t('confirmed')}`;
        if (index === this._currentIndex)
            return ` - ${this.$t('active')}`;
        return '';
    }
    _renderSaveArea() {
        if (!this.saveLabel)
            return '';
        return html `
      <div class="steppers-save d-flex border-top pt-3 mt-2" part="save">
        <div class="text-lg-end mb-2 mb-lg-0 me-lg-3">
          <p class="text-muted mb-0 small"><strong>${this.saveTitle}</strong></p>
          <p class="text-muted mb-0 small">${this.saveDescription}</p>
        </div>
        <it-button variant="secondary" outline type="button" @click=${this._handleSave} exportparts="focusable">
          ${this.saveLabel}
        </it-button>
      </div>
    `;
    }
    _renderProgressIndicator() {
        if (this.mobileProgress === 'bar')
            return this._renderProgressBar();
        if (this.mobileProgress === 'dots')
            return this._renderDots();
        return nothing;
    }
    render() {
        const stepperClasses = this.composeClass('steppers', {
            'bg-dark': this.dark,
            'mobile-progress-on-desktop': this.mobileProgressOnDesktop,
        });
        const isPrevDisabled = this._currentIndex <= 0;
        const isNextDisabled = this._currentIndex >= this._maxNavigableIndex;
        return html `
      <div class=${stepperClasses} part="stepper">
        <div class="steppers-header mb-3" part="header">
          <ul part="header-list">
            ${this._steps.map((step, i) => this._renderHeaderItem(step, i))}
          </ul>
          ${this._renderMobileIndex()}
        </div>
        <div class="steppers-content mb-3" aria-live="polite" part="content">
          <slot @slotchange=${this._handleSlotChange}></slot>
        </div>
        <nav class="steppers-nav mb-3" aria-label=${this.$t('navigation')} part="nav">
          <it-button
            type="button"
            variant="primary"
            outline
            size="sm"
            class="steppers-btn-prev"
            exportparts="focusable"
            ?disabled=${isPrevDisabled}
            @click=${this.prev}
          >
            <it-icon class="icon" name="it-chevron-left" color=${this.dark ? 'inverse' : 'primary'} size="sm"></it-icon>
            ${this.prevLabel || this.$t('back')}
          </it-button>

          ${this._renderProgressIndicator()}
          ${this.showConfirm
            ? html `
                <it-button
                  type="button"
                  variant="primary"
                  size="sm"
                  class="steppers-btn-confirm"
                  exportparts="focusable"
                  @click=${this._handleConfirm}
                >
                  ${this.confirmLabel || this.$t('confirm')}
                </it-button>
              `
            : html `
                <it-button
                  type="button"
                  variant="primary"
                  size="sm"
                  class="steppers-btn-next"
                  exportparts="focusable"
                  ?disabled=${isNextDisabled}
                  @click=${this.next}
                >
                  ${this.nextLabel || this.$t('next')}
                  <it-icon
                    class="icon"
                    name="it-chevron-right"
                    color=${this.dark ? 'primary' : 'inverse'}
                    size="sm"
                  ></it-icon>
                </it-button>
              `}
        </nav>
        ${this._renderSaveArea()}
      </div>
    `;
    }
};
ItStepper.styles = styles;
__decorate([
    property({ type: Number, reflect: true }),
    __metadata("design:type", Object)
], ItStepper.prototype, "current", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItStepper.prototype, "dark", void 0);
__decorate([
    property({ type: String, attribute: 'header-variant' }),
    __metadata("design:type", String)
], ItStepper.prototype, "headerVariant", void 0);
__decorate([
    property({ type: String, attribute: 'mobile-progress' }),
    __metadata("design:type", String)
], ItStepper.prototype, "mobileProgress", void 0);
__decorate([
    property({ type: Boolean, reflect: true, attribute: 'mobile-progress-on-desktop' }),
    __metadata("design:type", Object)
], ItStepper.prototype, "mobileProgressOnDesktop", void 0);
__decorate([
    property({ type: String, attribute: 'prev-label' }),
    __metadata("design:type", String)
], ItStepper.prototype, "prevLabel", void 0);
__decorate([
    property({ type: String, attribute: 'next-label' }),
    __metadata("design:type", String)
], ItStepper.prototype, "nextLabel", void 0);
__decorate([
    property({ type: String, attribute: 'confirm-label' }),
    __metadata("design:type", String)
], ItStepper.prototype, "confirmLabel", void 0);
__decorate([
    property({ type: Boolean, attribute: 'show-confirm' }),
    __metadata("design:type", Object)
], ItStepper.prototype, "showConfirm", void 0);
__decorate([
    property({ type: String, attribute: 'save-label' }),
    __metadata("design:type", String)
], ItStepper.prototype, "saveLabel", void 0);
__decorate([
    property({ type: String, attribute: 'save-title' }),
    __metadata("design:type", String)
], ItStepper.prototype, "saveTitle", void 0);
__decorate([
    property({ type: String, attribute: 'save-description' }),
    __metadata("design:type", String)
], ItStepper.prototype, "saveDescription", void 0);
ItStepper = __decorate([
    customElement('it-stepper')
], ItStepper);

export { ItStepper };
//# sourceMappingURL=it-stepper.js.map
